import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { useTheme } from '@emotion/react';
import Paper from '@segment/matcha/components/Paper';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Dropdown = function Dropdown(_ref) {
  var children = _ref.children;
  var theme = useTheme();
  return _jsx(Wrapper, {
    elevation: 4,
    borderRadius: 4,
    background: theme.palette.neutrals.white[100],
    children: children
  });
};

var Wrapper = /*#__PURE__*/_styled(Paper, true ? {
  target: "e6mri240"
} : {
  target: "e6mri240",
  label: "Wrapper"
})(true ? {
  name: "1xsxug3",
  styles: "display:grid;grid-template-columns:320px 390px;max-width:710px;width:100%;overflow:hidden"
} : {
  name: "1xsxug3",
  styles: "display:grid;grid-template-columns:320px 390px;max-width:710px;width:100%;overflow:hidden",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbi9EZXNrdG9wTmF2aWdhdGlvbi9Ecm9wZG93bi9Ecm9wZG93bi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUI2QiIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL05hdmlnYXRpb24vRGVza3RvcE5hdmlnYXRpb24vRHJvcGRvd24vRHJvcGRvd24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBGQywgUHJvcHNXaXRoQ2hpbGRyZW4gfSBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5pbXBvcnQgeyB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0J1xuXG5pbXBvcnQgUGFwZXIgZnJvbSAnQHNlZ21lbnQvbWF0Y2hhL2NvbXBvbmVudHMvUGFwZXInXG5cbmV4cG9ydCBjb25zdCBEcm9wZG93bjogRkM8UHJvcHNXaXRoQ2hpbGRyZW4+ID0gKHsgY2hpbGRyZW4gfSkgPT4ge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKClcblxuICByZXR1cm4gKFxuICAgIDxXcmFwcGVyIGVsZXZhdGlvbj17NH0gYm9yZGVyUmFkaXVzPXs0fSBiYWNrZ3JvdW5kPXt0aGVtZS5wYWxldHRlLm5ldXRyYWxzLndoaXRlWzEwMF19PlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvV3JhcHBlcj5cbiAgKVxufVxuXG5jb25zdCBXcmFwcGVyID0gc3R5bGVkKFBhcGVyKWBcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAzMjBweCAzOTBweDtcbiAgbWF4LXdpZHRoOiA3MTBweDtcbiAgd2lkdGg6IDEwMCU7XG4gIG92ZXJmbG93OiBoaWRkZW47XG5gXG5cbmV4cG9ydCBkZWZhdWx0IERyb3Bkb3duXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Dropdown;